import DropdownItem from './dropdown_item';
import DropdownExport from '../dropdown_export';

export default class Export extends DropdownItem {
  constructor() {
    super('export');
  }

  getValue(it) {
    return it.key;
  }

  dropdown() {
    return new DropdownExport();
  }
}
